import { OtpLogin } from '@/components/otp-login';

/** Pet-Owner login (route `/user/login`). Post-login → pets dashboard. */
export function UserLoginPage() {
  return (
    <OtpLogin
      role="user"
      title="Pet Owner"
      subtitle="Pet Marketplace · Manage your pets"
      success_path="/app/pets"
    />
  );
}
